import React from 'react';
import styles from './index.module.scss';
import { useScrollTrigger } from '@/hooks/useScrollTrigger';
import aixueai5Tealiu from '@/assets/aixueai5-tealiu.png';
import aixueai5Teashi from '@/assets/aixueai5-teashi.png';
import aixueai5Teayang from '@/assets/aixueai5-teayang.png';
import aixueai5Teayangying from '@/assets/aixueai5-teayangying.png';
import aixueai5Teazhu from '@/assets/aixueai5-teazhu.png';

export default function Screen5() {
  const rootRef = useScrollTrigger({
    triggerClass: styles['screen5-anim-start'],
    triggerRatio: 0.5,
    scrollContainerSelector: '.aixue-ai-scroll',
    enableResizeDetection: true
  });

  const masters = [
    {
      id: 1,
      name: '刘梦亚',
      role: '思维导师—刘梦亚',
      experience: '12年教学经验，',
      qualification: '北京知名讲师',
      image: aixueai5Tealiu
    },
    {
      id: 2,
      name: '杨思思',
      role: '人文导师-杨思思',
      experience: '16年教学经验，',
      qualification: '中国人民大学硕士',
      image: aixueai5Teayang
    },
    {
      id: 3,
      name: '史心语',
      role: '演说导师-史心语',
      experience: '10年教学经验，',
      qualification: '北京大学英语翻译专业硕士',
      image: aixueai5Teashi
    },
    {
      id: 4,
      name: '杨瑛',
      role: '科学导师-杨瑛',
      experience: '18年教学经验，',
      qualification: '原北京重点中学讲师',
      image: aixueai5Teayangying
    },
    {
      id: 5,
      name: '祝鑫',
      role: '实验导师-祝鑫',
      experience: '24年教学经验，',
      qualification: '高考把关教师',
      image: aixueai5Teazhu
    }
  ];

  return (
    <section className={styles['screen5-cover']} ref={rootRef}>
      <div className={styles['screen5-wrap']}>
        {/* 主标题 */}
        <h2 className={styles['screen5-title']}>专业的大师级保障</h2>
        
        {/* 副标题 */}
        <div className={styles['screen5-subtitle']}>
          沉淀顶尖行业专家方法论，与专业大师协同发力，共同打造领域新标杆
        </div>

        {/* 大师卡片容器 */}
        <div className={styles['screen5-masters-container']}>
          {masters.map((master) => (
            <div key={master.id} className={styles['screen5-master-card']}>
              {/* 老师图片 */}
              <div className={styles['screen5-image-section']}>
                <img 
                  src={master.image} 
                  alt={master.name}
                  className={styles['screen5-teacher-image']}
                />
              </div>
              
              {/* 内容区域 */}
              <div className={styles['screen5-content-section']}>
                <h3 className={styles['screen5-role']}>{master.role}</h3>
                <div className={styles['screen5-details']}>
                  <p className={styles['screen5-experience']}>{master.experience}</p>
                  {master.qualification && (
                    <p className={styles['screen5-qualification']}>{master.qualification}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
